export default "/images/fr.svg?762413013ba856902dde1b652b8f9b1f";